import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { Button } from "@mui/material";
import EventController from "../Controller/event_controller.ts";
import { RiFileExcel2Line } from "react-icons/ri";

const EventRegistrationExcel = ({ eventID }) => {
  const [combinedData, setCombinedData] = useState([]);

  useEffect(() => {
    fetchEventData();
  }, [eventID]);

  const fetchEventData = async () => {
    try {
      const data = await EventController.getEventRegistrationInfoExcel(eventID);
      
      const formattedData = data.flatMap((item, index) => {
        if (item.beneficiary.length === 0) {
          return [{
            "No.": index + 1,
            "Event Registration Number": item.event_registrationID,
            "Company Name": item.billing_name,
            "Company Address": item.billing_address,
            "Mall Name": item.complex_representing || item.billing_name || item.contact_name,
            "Member/Non Member": "Member",
            "RPM": "",
            "HRD Claim": item.hrd_claim_status === '1' ? "Yes" : "No",
            "Contact Salutation": item.contact_salutation || item.contact_other_salutation,
            "Contact Person": item.contact_name,
            "Contact Person H/P": item.contact_hp,
            "Contact Person Email": item.contact_email,
            // "Salute": "",
            "Participant Name": "",
            "NRIC": "",
            "Position": "",
            "H/P": "",
            "Email": "",
            "Dietary Restriction": "",
            "DATE TIME REGISTERED": item.datetime_registered,
          }];
        }

        return item.beneficiary.map((beneficiary) => ({
          "No.": index + 1,
          "Event Registration Number": item.event_registrationID,
          "Company Name": item.billing_name,
          "Company Address": item.billing_address,
          "Mall Name": item.complex_representing || item.billing_name || item.contact_name,
          "Member/Non Member": "Member",
          "RPM": beneficiary.rpm_no,
          "HRD Claim": item.hrd_claim_status === '1' ? "Yes" : "No",
          "Contact Salutation": item.contact_salutation || item.contact_other_salutation,
          "Contact Person": item.contact_name,
          "Contact Person H/P": item.contact_hp,
          "Contact Person Email": item.contact_email,
          // "Salute": beneficiary.salute,
          "Participant Name": beneficiary.name,
          "NRIC": beneficiary.nric,
          "Position": beneficiary.designation,
          "H/P": beneficiary.phone || "N/A",
          "Email": beneficiary.email,
          "Dietary Restriction": 
            beneficiary.dietary_option !== undefined && beneficiary.dietary_option !== null
              ? (beneficiary.dietary_option == 0 ? "Non-Vegetarian" : "Vegetarian")
              : (item.dietary_options == 0 ? "Non-Vegetarian" : "Vegetarian"),
          "DATE TIME REGISTERED": item.datetime_registered,
        }));
      });

      setCombinedData(formattedData);
    } catch (error) {
      console.error("Error fetching event registration data:", error);
    }
  };

  const exportToExcel = async () => {
    try {
      await fetchEventData(); // Fetch latest data before exporting

      if (combinedData.length === 0) {
        alert("No data available!");
        return;
      }

      const worksheet = XLSX.utils.json_to_sheet(combinedData);

      // Auto-resize column widths
      const columnWidths = Object.keys(combinedData[0]).map((key) => ({
        wch: Math.max(
          key.length,
          ...combinedData.map((row) => (row[key] ? row[key].toString().length : 0))
        ),
      }));

      worksheet["!cols"] = columnWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Event Registrations");
      XLSX.writeFile(workbook, `EventRegistrationList-${eventID}.xlsx`);
      
    } catch (error) {
      console.error("Error exporting to Excel:", error);
    }
  };

  return (
    <Button 
      variant="contained" 
      color="success" 
      onClick={exportToExcel} 
      sx={{ marginBottom: "20px", fontWeight: "bold" }}
    >
      <RiFileExcel2Line fontSize={20} style={{ marginRight: "10px" }} /> Excel
    </Button>
  );
};

export default EventRegistrationExcel;
